import React, { useState, useEffect } from 'react';
import { IoIosArrowUp } from "react-icons/io";
import styles from './ScrollToTop.module.scss'; 

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleButtonClick = () => {
    setIsClicked(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => setIsClicked(false), 300); // Reset click animation
  };

  return (
    <button
      className={`${styles['scroll-to-top']} ${isVisible ? styles.show : ''} ${
        isClicked ? styles.clicked : ''
      }`}
      onClick={handleButtonClick}
    >
      <IoIosArrowUp className={styles.icon} />
    </button>
  );
}

export default ScrollToTop;
